import NavComponent from "../lib/nav_component";

export const PrimaryPaneBodyComponentConfig = {
    baseHtmlClass: 'nav__pane__body--primary',
    selector: '.nav__pane__body--primary',

    contentElementSelector: '.nav__pane__body__content',
    hasScrolledDefaultThreshold: 100,
    scrolledThresholdElementSelector: '[data-PrimaryPaneBodyComponentScrollThreshold]',
};

export class PrimaryPaneBodyComponent extends NavComponent {

    constructor(id_or_element, primaryPaneComponent) {
        super(id_or_element, PrimaryPaneBodyComponentConfig);

        this.primaryPaneComponent = primaryPaneComponent;

        this.contentElement = this.element.querySelector(PrimaryPaneBodyComponentConfig.contentElementSelector);
        this.scrolledThreshold = this.getScrolledThreshold();

        this.scrollTicking = false;
        this.contentScrollTop = this.contentElement.scrollTop;
        this.hasContentScrolledDown = false;
        this.contentElement.addEventListener('scroll', this.handleScroll.bind(this));
    }

    handleScroll(event) {
        if (!this.scrollTicking) {
            requestAnimationFrame((timestamp) => {
                this.contentScrollTop = this.contentElement.scrollTop;
                this.hasContentScrolledDown = this.hasScrolledDown();
                this.primaryPaneComponent.setBodyContentScrolled(this.hasScrolledDown());
                // this.primaryPaneComponent.setBodyContentScrollPercent(this.scrolledDownPercent());
                this.scrollTicking = false;
            });
        }
        this.scrollTicking = true;
    }

    hasScrolledDown() {
        return this.contentScrollTop >= this.scrolledThreshold;
    }

    // The percentage scrolled down of the threshold.
    // Disable until we actually need this.
    // scrolledDownPercent() {
    //     const percent = (this.contentScrollTop / this.scrolledThreshold) * 100;
    //     return Math.ceil(percent *100) / 100; // Rounds to 2 significant places.
    // }

    render() {
    }

    getScrolledThreshold() {
        const element = this.element.querySelector(PrimaryPaneBodyComponentConfig.scrolledThresholdElementSelector);
        let threshold = (!!element ? element.offsetHeight : PrimaryPaneBodyComponentConfig.hasScrolledDefaultThreshold);
        return threshold;
    }

    adjustScrolledThreshold(amount) {
        this.scrolledThreshold = this.scrolledThreshold + amount;
    }

}
